<div class="setting" [formGroup]="form">
  <div class="input-container" *ngIf="data.filterType === 'purchasing' || this.data.filterType === 'purchase-by-sku'">
    <label for="" class="input-container_label">Vendor</label>
    <input
      type="text"
      class="input-container_input input-container_input--extra-thin"
      formControlName="vendor"
      [matAutocomplete]="auto"
      placeholder="Search"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
      <mat-option
        *ngFor="let option of filteredOptions$ | async"
        [value]="option"
        class="mat-option-override"
      >
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
    <div class="input-container mt-2">
      <label for="" class="input-container_label">Tags</label>
      <div class="position-relative input-container_tags">
        <select  class="input-container_input input-container_input--extra-thin" formControlName="tag">
          <option value="all">Select</option>
          <option [value]="tag.name" *ngFor="let tag of allTags">{{tag.name}}</option>
        </select>
        <span class="arrow-icon"><i class="fal fa-chevron-down"></i></span>
      </div>
    </div>

  <div class="setting_footer mt-3">
    <app-button [buttonSize]="'action'" (click)="save()">Save</app-button>
  </div>
</div>

  <div class="input-container" *ngIf="data.filterType === 'replenish'">
    <app-page-container-devider
    [title]="'warehouse'"
    [small]="true"
    class="mb-3"
  ></app-page-container-devider>

    <div class="setting_container">
    <div class="input-container">
      <label class="input-container_label">Replenish from warehouse</label>
      <div class="box_detail">
        <input type="text" class="input-container_input input-container_input--thin"
          placeholder="Search" formControlName="replenishwarehouse" [matAutocomplete]="auto" 
          matAutocompletePosition="below" (click)="searchWarehouse()"/>
        <mat-autocomplete #auto="matAutocomplete" class="mat-select-panel" [displayWith]="displayWithWarehouse">
          <mat-option *ngFor="let option of filterOptionsWarehouse | async" [value]="option">{{option.name}}<small class="whAddress-text">({{option.city ? option.city+',' : ''}}{{option.state}})</small>
          </mat-option>
        </mat-autocomplete>
  </div>
    </div>
  <div class="gap_top_1" >
    <label class="d-flex">
      <mat-checkbox formControlName="replenishnostock"
       class="mat-checkbox-sm me-2">
      </mat-checkbox> Load SKUs with local stock only</label
    >
</div>
</div>
 <!--<app-page-container-devider
  [title]="'Skus With Input'"
  [small]="true"
  class="mb-2 mt-3"
  ></app-page-container-devider>
  <div>
    <label class="d-flex">
      <mat-checkbox formControlName="queuedSku"
       class="mat-ceckbox-sm me-2">
      </mat-checkbox> Show skus with input greater than 0</label
    >
</div>-->
  <div class="setting_footer mt-3">
    <app-button
      [buttonSize]="'action'"
      [spin]="showLoader"
      (click)="save()"
      
      >Apply</app-button
    >
    </div>
 </div>
</div>
